exports.onRouteUpdate = ({location}) => {
  if (window.MathJax !== undefined && location.pathname.indexOf("/research/") === 0) {
    window.MathJax.Hub.Queue(['Typeset', window.MathJax.Hub]);
  }
};
